export default __webpack_public_path__ + "36f71f434e2814b6ed9f4ea63b889f4a.webp";